/**
 * tdesign v1.0.6
 * (c) 2023 TDesign Group
 * @license MIT
 */

import { getCurrentInstance } from 'vue';

var withInstall = function withInstall(comp, alias) {
  var c = comp;
  c.install = function (app, name) {
    var defaultName = c.name;
    app.component(alias || name || defaultName, comp);
  };
  return c;
};
function extendAPI(apis) {
  var instance = getCurrentInstance();
  if (instance && instance.proxy) {
    Object.assign(instance.proxy, apis);
  }
}

export { withInstall as default, extendAPI, withInstall };
//# sourceMappingURL=component.js.map
